module.exports = __webpack_public_path__ + "img/3.61fd0c7e.jpg";